// Redux Reducers
import {
  SET_MB_STORE,
  ADD_MB_TYPE,
  REMOVE_MB_TYPE,
  SET_MB_PATH_CUSTOM
} from "../types";

const initialState = {
  MBStore: null,
  MBPathCustom: ''
};

function mybeaportReducer(state = initialState, action) {

  if (action.type === SET_MB_STORE) {
    return { ...state, MBStore: action.payload }
  }

  if (action.type === ADD_MB_TYPE) {
    const { id, category } = action;
    let store = { ...state.MBStore };
    store[category].push(id);
    return { ...state, MBStore: store }
  }

  if (action.type === REMOVE_MB_TYPE) {
    const { id, category } = action;
    let store = { ...state.MBStore };
    const index = store[category].findIndex( x => x === id );
    store[category].splice(index, 1);
    return { ...state, MBStore: store }
  }

  if (action.type === SET_MB_PATH_CUSTOM) {
    return { ...state, MBPathCustom: action.payload }
  }

  return state;
};

export default mybeaportReducer;
